import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useGoogleBusinessManagerStore = defineStore({
  id: 'googleBusinessManagerStore',
  state: () => ({
    googleBusinessManagers: [],
    googleBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getGoogleBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.googleBusinessManagersLoading = true

      try {
        const {data} = await axios.get('google/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.googleBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.googleBusinessManagersLoading = false
      }
    },
  },
})
